<ng-container *ngIf="announcements">
  <header-announcement-custom-element>
    <span style="display: none">{{ {announcements, shortLocale} | json }}</span>
  </header-announcement-custom-element>
</ng-container>
